import { jsx } from "react/jsx-runtime";
import react, { useEffect } from "react";
import { TravelBotChatSingleDialogGeneric } from "./TravelBotChatSingleDialogGeneric.js";
let count = 0;
const BlockingInputComponent = /*#__PURE__*/ react.memo((props)=>{
    const { setIsDisablingInputValue } = props;
    const shouldBlockInput = 5 === count;
    useEffect(()=>{
        if (shouldBlockInput) {
            setIsDisablingInputValue(true);
            setTimeout(()=>{
                setIsDisablingInputValue(false);
            }, 30000);
        } else count++;
    }, []);
    return shouldBlockInput ? /*#__PURE__*/ jsx(TravelBotChatSingleDialogGeneric, {
        message: {
            role: 'assistant',
            content: 'Sorry, service will be disabled for 30s.'
        }
    }) : null;
});
export { BlockingInputComponent };
